export default __webpack_public_path__ + "static/media/ourwork.f34fbc21.svg";